import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  IconButton,
  Tooltip,
  Button
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import KanbanBoard from '../components/KanbanBoard';

// Glassmorphism style
const glassStyle = {
  background: 'rgba(255, 255, 255, 0.7)',
  backdropFilter: 'blur(20px)',
  border: '1px solid rgba(255, 255, 255, 0.3)',
};

const Pipelines = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{
      height: '100%',
      width: '100%',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      background: 'linear-gradient(135deg, #f0f4f8 0%, #e2e8f0 100%)',
      p: 2,
      gap: 2,
      boxSizing: 'border-box'
    }}>
      {/* Header */}
      <Box sx={{
        ...glassStyle,
        borderRadius: 3,
        px: 3,
        py: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 4px 20px rgba(0,0,0,0.05)'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{
            width: 44,
            height: 44,
            borderRadius: 2.5,
            background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <ViewKanbanIcon sx={{ color: '#fff', fontSize: 24 }} />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#1f2937' }}>
              Pipeline de Vendas
            </Typography>
            <Typography variant="body2" sx={{ color: '#6b7280' }}>
              Visualize e gerencie seus processos de vendas
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {/* Dica */}
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            px: 2,
            py: 1,
            borderRadius: 2,
            background: 'rgba(99,102,241,0.1)',
            border: '1px solid rgba(99,102,241,0.2)'
          }}>
            <InfoOutlinedIcon sx={{ fontSize: 18, color: '#6366f1' }} />
            <Typography variant="body2" sx={{ color: '#6366f1', fontSize: 13 }}>
              Arraste oportunidades entre os estágios
            </Typography>
          </Box>

          {/* Botão de Gestão */}
          <Button
            onClick={() => navigate('/pipelines/management')}
            startIcon={<SettingsIcon />}
            sx={{
              px: 2.5,
              py: 1,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              fontSize: 13,
              color: '#374151',
              background: 'rgba(255,255,255,0.8)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(0,0,0,0.05)',
              '&:hover': {
                background: 'rgba(255,255,255,0.95)',
                borderColor: '#6366f1'
              }
            }}
          >
            Gestão de Pipelines
          </Button>
        </Box>
      </Box>

      {/* Kanban Board Area */}
      <Box sx={{
        flex: 1,
        minWidth: 0, // Importante para flex container respeitar limites
        minHeight: 0, // Importante para flex container respeitar limites verticais
        ...glassStyle,
        borderRadius: 3,
        overflow: 'hidden',
        boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <KanbanBoard />
      </Box>
    </Box>
  );
};

export default Pipelines;
